/** Headers for same-origin JSON requests (e.g. Rails `render json:` + CSRF). */
export function jsonHeaders() {
  const token = document.querySelector('meta[name="csrf-token"]')?.content;
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    ...(token ? { "X-CSRF-Token": token } : {}),
  };
}
